import { takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  FETCH_ACTIVITIES,
  LOG_EXTERNAL_WORKOUT,
  UPDATE_EXTERNAL_WORKOUT,
} from 'actions/activities';
import { USER_ACTION_TYPES } from 'actions/user';
import {
  PROGRAMS_ACTION_TYPES,
  SCHEDULE_ACTION_TYPES,
  PROGRAM_SCHEDULE_ACTION_TYPES,
  PROGRAM_TRACK_ACTION_TYPES,
  RESTART_PROGRAM_ACTION_TYPES,
} from 'actions/programs';
import { FETCH_ACHIEVEMENTS } from '../actions/achievements';
import { FETCH_ERROR_HANDLER } from '../actions/fetchErrorHandler';
import { ADVERTISEMENT_PRODUCT, ANNOUNCEMENT } from '../actions/advertisement';
import {
  FETCH_QUESTIONNAIRE,
  SEND_QUESTIONNAIRE_ANSWERS,
  FETCH_QUESTIONNAIRE_ANSWERS,
} from '../actions/questionnaire';
import { FETCH_PROGRAM_SESSION_BY_ID, FETCH_EXPANDED_SESSION_INFO } from '../actions/sessions';
import { GET_PRODUCT_DATA, REDIRECT_TO_STRIPE_CHECKOUT } from '../actions/products';
import {
  FETCH_SESSION_EXERCISES_LIST,
  FETCH_EXERCISE_BY_ID,
  COMPLETE_EXERCISE,
} from '../actions/exercise';
import {
  FETCH_WORKOUT_SESSIONS,
  FETCH_WORKOUT_SESSIONS_PROGRAM,
  FETCH_WORKOUT_SESSION_BY_ID,
  FETCH_WORKOUT_SESSION,
  CREATE_WORKOUT,
  CREATE_PREPARE_PHASE_ANSWER,
  DONE_WORKOUT,
  FETCH_RESUME_WORKOUT,
  START_EXERCISE,
  UPDATE_WORKOUT_SURVEY,
  SAVE_RATING,
} from '../actions/workout';
import fetchAchievements from './achievements';
import fetchErrorHandler from './fetchErrorHandler';
import { fetchAdvertisementProduct, fetchAnnouncement } from './advertisement';
import { fetchPurchasedProduct, redirectToStripeCheckout } from './products';
import {
  fetchQuestionnaire,
  fetchUserQuestionnaireAnswers,
  sendQuestionnaireAnswers,
} from './questionnaire';
import { fetchProgramSessionById, fetchExpandedSessionInfo } from './sessions';
import {
  fetchSessionExercisesList,
  startExercise,
  fetchExerciseById,
  completeExercise,
} from './exercises';
import { fetchUser, updateUser } from './user';
import {
  fetchUserWorkoutSessions,
  fetchProgramWorkoutSession,
  fetchUserWorkoutSessionById,
  createUserWorkout,
  createPreparePhaseAnswer,
  doneWorkout,
  updateWorkoutSurvey,
  saveRating,
  fetchResumeWorkout,
  fetchWorkoutSession,
} from './workout';
import fetchActivities, { logExternalWorkout, updateExternalWorkout } from './activities';
import {
  fetchPrograms,
  updateProgramsSchedule,
  updateProgramSchedule,
  changeProgramTrack,
  restartProgram,
} from './programs';
import { AVAILABLE_PROGRAMS_ACTION_TYPES } from 'actions/availablePrograms';
import { fetchAvailablePrograms } from './availablePrograms';

export default function* root() {
  yield all([
    takeLatest(FETCH_QUESTIONNAIRE.request, fetchQuestionnaire),
    takeLatest(SEND_QUESTIONNAIRE_ANSWERS.request, sendQuestionnaireAnswers),
    takeLatest(USER_ACTION_TYPES.REQUEST, fetchUser),
    takeLatest(USER_ACTION_TYPES.UPDATE_REQUEST, updateUser),
    takeLatest(FETCH_ACTIVITIES.request, fetchActivities),
    takeLatest(LOG_EXTERNAL_WORKOUT.request, logExternalWorkout),
    takeLatest(UPDATE_EXTERNAL_WORKOUT.request, updateExternalWorkout),
    takeLatest(PROGRAMS_ACTION_TYPES.LOADING, fetchPrograms),
    takeLatest(AVAILABLE_PROGRAMS_ACTION_TYPES.LOADING, fetchAvailablePrograms),
    takeLatest(SCHEDULE_ACTION_TYPES.UPDATING, updateProgramsSchedule),
    takeLatest(FETCH_WORKOUT_SESSIONS.request, fetchUserWorkoutSessions),
    takeLatest(FETCH_QUESTIONNAIRE_ANSWERS.request, fetchUserQuestionnaireAnswers),
    takeLatest(FETCH_WORKOUT_SESSIONS_PROGRAM.request, fetchProgramWorkoutSession),
    takeLatest(FETCH_PROGRAM_SESSION_BY_ID.request, fetchProgramSessionById),
    takeLatest(FETCH_WORKOUT_SESSION_BY_ID.request, fetchUserWorkoutSessionById),
    takeLatest(CREATE_WORKOUT.request, createUserWorkout),
    takeLatest(FETCH_SESSION_EXERCISES_LIST.request, fetchSessionExercisesList),
    takeLatest(START_EXERCISE.request, startExercise),
    takeLatest(FETCH_EXERCISE_BY_ID.request, fetchExerciseById),
    takeLatest(CREATE_PREPARE_PHASE_ANSWER.request, createPreparePhaseAnswer),
    takeLatest(DONE_WORKOUT.request, doneWorkout),
    takeLatest(COMPLETE_EXERCISE.request, completeExercise),
    takeLatest(UPDATE_WORKOUT_SURVEY.request, updateWorkoutSurvey),
    takeEvery(SAVE_RATING.request, saveRating),
    takeLatest(FETCH_ACHIEVEMENTS.request, fetchAchievements),
    takeLatest(FETCH_RESUME_WORKOUT.request, fetchResumeWorkout),
    takeLatest(FETCH_WORKOUT_SESSION.request, fetchWorkoutSession),
    takeLatest(REDIRECT_TO_STRIPE_CHECKOUT.request, redirectToStripeCheckout),
    takeLatest(GET_PRODUCT_DATA.request, fetchPurchasedProduct),
    takeLatest(FETCH_ERROR_HANDLER, fetchErrorHandler),
    takeLatest(ADVERTISEMENT_PRODUCT.request, fetchAdvertisementProduct),
    takeLatest(ANNOUNCEMENT.request, fetchAnnouncement),
    takeLatest(FETCH_EXPANDED_SESSION_INFO.request, fetchExpandedSessionInfo),
    takeLatest(PROGRAM_SCHEDULE_ACTION_TYPES.UPDATING, updateProgramSchedule),
    takeLatest(PROGRAM_TRACK_ACTION_TYPES.CHANGING, changeProgramTrack),
    takeLatest(RESTART_PROGRAM_ACTION_TYPES.RESTARTING, restartProgram),
  ]);
}
